const e=e=>e.replace(/([a-z])([A-Z])/g,"$1_$2").toLowerCase(),a=e=>e.charAt(0).toUpperCase()+e.slice(1);export{e as camelCaseToSnakeCase,a as capitalizeFirstLetter};
//# sourceMappingURL=textUtils.js.map
